import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DemoMaterialModule } from '../demo-material-module';

import { RouterModule } from '@angular/router';
import { ChartistModule } from 'ng-chartist';
import { ChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { FaqRoutingModule } from './faq-routing.module';
import { CategoriesComponent } from './categories/categories.component';
import { CategoryDialogComponent } from './category-dialog/category-dialog.component';
import { FaqsComponent } from './faqs/faqs.component';
import { FaqDialogComponent } from './faq-dialog/faq-dialog.component';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    CategoriesComponent,
    CategoryDialogComponent,
    FaqsComponent,
    FaqDialogComponent
  ],
  imports: [
    CommonModule,
    FaqRoutingModule,
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    NgxDatatableModule,
    FlexLayoutModule,
    RouterModule,
    ChartistModule,
    NgApexchartsModule,
    ChartsModule,
    MatSelectModule
  ]
})
export class FaqModule {
  
 }
